:host {
  @apply block;
}

:host(.button-disabled) {
  @apply cursor-default pointer-events-none;
}

button, a {
  background-size: 220% 200% !important;
  &:hover, &:focus, &:active {
    background-position: -90% 0% !important;
  }
  // Icon Visible
  &.button-icon-visible {
    @apply pl-[15px] pr-[15px];
    .button-label {
      @apply relative text-left pr-[20px] -top-[2px];
    }
    .button-icon {
      @apply inline;
    }
  }
  // Icon Hover
  &.button-icon-hover {
    .button-label {
      @apply pl-[35px] pr-0 relative -top-[2px];
      transition: all 0.3s ease, color 0.1s ease;
    }
    .button-icon {
      @apply inline text-white opacity-0 pr-[25px] ml-[-10px] pl-0 transition-all duration-[300ms];
    }
    &:hover {
      .button-label {
        @apply sm:text-left sm:pl-[15px] sm:pr-[5px];
      }
      .button-icon {
        @apply sm:opacity-100 sm:ml-0 sm:pr-[10px] sm:pl-[15px];
      }
    }
  }
  // Icon Hidden
  &.button-icon-hidden {
    .button-label {
      @apply px-[35px] relative -top-[2px];
    }
    .button-icon {
      @apply hidden;
    }
  }
  // Color Default
  &.button-default {
    @apply text-grey border-grey;
    background: linear-gradient(90deg, var(--vt-color-white, #fff) 50%, var(--vt-color-grey-default, #4B4B46) 50%);
    &:hover, &:focus, &:active {
      @apply text-white bg-grey;
    }
  }
  // Color Berry
  &.button-berry {
    @apply text-berry border-berry;
    background: linear-gradient(90deg, var(--vt-color-white, #fff) 50%, var(--vt-color-berry-default, #D7004B) 50%);
    &:hover, &:focus, &:active {
      @apply text-white bg-berry;
    }
  }
  // Background Transparent
  &.button-transparent {
    background: transparent !important;
    &.button-default {
      color: #4B4B46 !important;
      .button-icon {
        color: #4B4B46 !important;;
      }
    }
    &.button-berry {
      color: #D7004B !important;
      .button-icon {
        color: #D7004B !important;;
      }
    }
  }
}
